/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { MemberManagerRegisterLineResponse } from "./MemberManagerRegisterLineResponse";

export type MemberManagerRegisterLineResponseApiRespoonse = {
  data?: MemberManagerRegisterLineResponse;
  status?: MemberManagerRegisterLineResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace MemberManagerRegisterLineResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
